// 028B-1 — Curva de Crecimiento Niño de 2 meses a 5 años (corrección de
// numeración, ver PLAN.md Serie 028 — antes "028A2", código incorrecto).
import { crearFormularioCurvaCrecimiento } from './curvaCrecimiento';

export const Formulario028B1 = crearFormularioCurvaCrecimiento({ claveI18n: 'f028b1', incluirPosicionTalla: true, incluirPerimetroCefalico: true, curvasPdf: 'oms0a5' });
